<template>
  <div>
    <v-text-field
      v-bind="childProps"
      :value="rawInput"
      :error-messages="computedErrorMessages"
      :hide-details="computedHideDetails"
      type="text"
      inputmode="decimal"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      @click="onClick"
    >
      <template
        v-if="hasLabelContent"
        slot="label"
      >
        <span v-if="fieldLabel">{{ fieldLabel }}</span>
        <span
          v-if="previewLabel"
          class="currency-field__preview"
        >
          {{ fieldLabel ? `(${previewLabel})` : previewLabel }}
        </span>
      </template>
    </v-text-field>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.currency-field__preview {
  font-weight: 700;
  padding-left: 4px;
}
</style>

<script>
import src from './src'
export default src
</script>
